import { DocumentCategory } from 'enums/DocumentCategory';
import { BusinessEntityStructure } from 'pages/ContractorPortal/steps/ContractorApplication/contractorApplication.enums';
import { Lender } from 'enums/ApplicationsVariables';

import { ApplicationDto } from './ApplicationApi';
import { HttpClient } from './HttpClient';
import { Address } from './IntermediaryApplicationsApi';

export enum ExtractionDocumentType {
  WorkOrder = 'Work Order Contract',
}

export interface UploadDocumentsRequest {
  applicationId: string;
  files: File[];
  documentVariablePrefix: string;
  documentCategory: DocumentCategory;
  extractDocument: boolean;
  documentType?: ExtractionDocumentType;
}

export interface DownloadTranscriptAuthorizationRequest {
  firstName: string;
  lastName: string;
  ssn: string;
  streetName: string;
  streetNumber: string;
  city: string;
  state: string;
  zip: string;
}

export interface MasterDealerAgreementRequest {
  federalTaxId: string;
  legalBusinessName: string;
  entityStructure: BusinessEntityStructure;
  mainContactFirstName: string;
  mainContactLastName: string;
  mainContactPosition: string;
  businessAddress: Address;
  phone: string;
  email: string;
  signerFirstName?: string | null;
  signerLastName?: string | null;
  whoSignedMasterDealerAgreement: string;
}

export default class DocumentsApi extends HttpClient {
  public constructor() {
    super(process.env.REACT_APP_API_URL + '/documents' || '');
  }

  public async uploadDocuments({
    applicationId,
    files,
    documentVariablePrefix,
    extractDocument,
    documentType,
  }: UploadDocumentsRequest): Promise<ApplicationDto> {
    const formData = new FormData();

    formData.set('applicationId', applicationId);
    formData.set('documentVariablePrefix', documentVariablePrefix);
    formData.set('extractDocument', extractDocument.toString());

    if (documentType) {
      formData.set('documentType', documentType);
    }

    files.forEach((file) => {
      formData.append(`files`, file, file.name);
    });

    return this.instance.post(`/upload`, formData).then((response) => response.data);
  }

  public async downloadCreditServicesAgreement(applicationId: string, lender: Lender): Promise<any> {
    return this.instance
      .get(`/credit-services-agreements?applicationId=${applicationId}&lender=${lender}`)
      .then((response) => response.data);
  }

  public async downloadTranscriptAuthorization(
    downloadTranscriptAuthorizationRequest: DownloadTranscriptAuthorizationRequest,
  ): Promise<any> {
    return this.instance
      .post('/transcript-authorization', downloadTranscriptAuthorizationRequest)
      .then((response) => response.data);
  }

  public async downloadMasterDealerAgreement(body: MasterDealerAgreementRequest): Promise<any> {
    return this.instance.post(`/master-dealer-agreement`, body).then((response) => response.data);
  }
}

export const documentsApi = new DocumentsApi();
